import {
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import {
  compareValues,
  SortDirection,
  toggleSortDirection,
} from '../../../lib/utils/sort';
import { UserService } from '../../../services';
import { User } from '../../../types';

@Component({
  selector: 'app-user-table',
  templateUrl: './user-table.component.html',
  styleUrls: ['./user-table.component.scss'],
})
export class UserTableComponent implements OnInit {
  @HostBinding('class.entity-table-component')
  hostClass = true;

  sortColumn: keyof User = 'firstname';
  sortDirection: SortDirection = 'asc';

  selected: User[] = [];

  constructor(public userService: UserService) {}

  ngOnInit(): void {
    this.sortColumn = this.userService.listState.filter
      .sort as keyof User;
    this.sortDirection =
      this.userService.listState.filter.direction;

    this.userService.loadList();

    this.userService.loadingCounter$.subscribe(() => {
      this.selected = [];
    });
  }

  get items(): User[] {
    return this.userService.listState.response.items;
  }

  get selection() {
    return {
      selected: this.selected,
    };
  }

  sortBy(column: keyof User): void {
    const next = toggleSortDirection(
      this.sortColumn,
      column,
      this.sortDirection
    );
    this.sortColumn = next.column;
    this.sortDirection = next.direction;

    this.userService.listState.filter.sort =
      this.sortColumn;
    this.userService.listState.filter.direction =
      this.sortDirection;

    this.userService.loadList();
  }

  isAllSelected(): boolean {
    return (
      this.selected.length === this.items.length &&
      this.items.length > 0
    );
  }

  toggleAllRows(): void {
    this.isAllSelected()
      ? (this.selected = [])
      : (this.selected = [...this.items]);
  }

  toggleRow(user: User): void {
    const index = this.selected.findIndex(
      (u) => u.id === user.id
    );
    if (index >= 0) {
      this.selected.splice(index, 1);
    } else {
      this.selected.push(user);
    }
  }

  isSelected(user: User): boolean {
    return this.selected.some((u) => u.id === user.id);
  }

  async deleteUsers(): Promise<void> {
    for (const { id } of this.selected) {
      await this.userService.delete(id);
    }
    this.selected = [];
    this.userService.loadList();
  }

  private sortArray(array: User[]): User[] {
    return array.sort((a, b) => {
      const aVal = a[this.sortColumn] ?? '';
      const bVal = b[this.sortColumn] ?? '';
      return compareValues(aVal, bVal, this.sortDirection);
    });
  }
}
